import { IsIPad } from "../../utils/IsIPad";

/**
 * Multiplier to game speed (divider to duration) of all animation- and timer-based in-game processes
 */
export enum GameSpeed {
    SLOW = 0.5,
    NORMAL = 1,
    FAST = 2,
    VERY_FAST = 4,
}

/**
 * Default: -1 (CCW)
 */
export enum GamePlayDirection {
    CW = 1,
    CCW = -1,
}

export enum CardsSorting {
    RIGHT_HANDED,
    LEFT_HANDED,
}

export enum AutomaticPlay {
    NEVER,
    AS_SOON_AS_POSSIBLE,
    LAST_ONLY,
}

/**
 * Internal application settings
 * - timings
 * - eases
 */
export class AppSettings {
    public static colors = {
        black: 0x000000,
        white: 0xffffff,
        yellow: 0xfcca22,
        orange: 0xff9000,
        red: 0xdd0102,
        green: 0x007602,

        blackString: "#000000",
        whiteString: "#ffffff",
        yellowString: "#fcca22",
        orangeString: "#ffae00",
        redString: "#dd0102",

        cardDarkenColor: 0xAAAAAA,
    };

    public static fontFamilies = {
        MontserratMedium: "MontserratMedium",
        MontserratBold: "MontserratBold",
        MontserratBlack: "MontserratBlack",
    };

    // public static timing = {
    //     // generic
    //     genericShowDuration: 1000,
    //     genericHideDuration: 1000,
    //     // specific
    //     // screenShowDuration: 500,
    //     // screenHideDuration: 500,
    //     screenShowDuration: 1000,
    //     screenHideDuration: 1000,
    //     hintBubbleShowDuration: 500,
    //     hintBubbleHideDuration: 500,
    //     majorDeclarationShowDuration: 500,
    //     majorDeclarationHideDuration: 500,
    //     majorDeclarationVisibleDuration: 3000,
    //     textBubbleDuration: 2000,
    //     simpleDeclarationDuration: 1000,
    //     cardFlipNextTaskDelay: 1000,
    //     cardReorderDuration: 1000,
    //     preDealTableToPlayerDelay: 1000,
    //     cardDealTableToPlayerDuration: 300,
    //     cardDealTableToPlayerDelay: 70,
    //     trickCollectDuration: 500,
    //     trickCollectItemDelay: 80,
    //     cardDealPlayerToTableDuration: 300,
    //     /**
    //      * This is AFTER card is deals on table. 
    //      * For all 4 players, even autoPlay.
    //      */
    //     cardDealPlayerToTableDelay: 1000,
    //     cardDealCardNudgeDuration: 200,
    //     cardFlipDuration: 400,
    //     preTrickCollectDelay: 500,
    //     postTrickCollectDelay: 500,
    //     cardHighlightDuration: 500,
    //     /**
    //      * Pause before leaving table and showing deal complete screen
    //      */
    //     preDealCompleteScreenDelay: 1000,
    //     scrollableContentScrollDuration: 600,
    // };

    public static general = {
        // /**
        //  * Affects inner conent scale
        //  */
        // scalingReferenceScrollableContentScreenWidth: 1000,
        // /**
        //  * Affects max container width
        //  */
        // defaultScrollableContentScreenWidth: 1500,
        /**
         * Card size can be grabbed from card frame in any loaded card deck atlas.
         * Used in: 
         * > positioning of Hints bubble just above cards.
         */
        cardWidth: 264,
        cardHeight: 384,
        screenExcessHideOverflow: 70,
    };

    public static ease = {
        genericShowHideEase: (t: number) => Phaser.Math.Easing.Elastic.Out(t, 0.8, 1.2),
        screenShowHideEase: (t: number) => Phaser.Math.Easing.Elastic.Out(t, 0.8, 1.2),
        genericShowHideEaseNoOvershoot: Phaser.Math.Easing.Cubic.InOut,
        genericDealEase: Phaser.Math.Easing.Cubic.InOut,
        scrollableContentScrollEase: Phaser.Math.Easing.Quadratic.InOut,
    };

    public static metrics = {
        montserratMedium30: { ascent: 27, descent: 6, fontSize: 33 },
        montserratMedium35: { ascent: 31, descent: 7, fontSize: 38 },
        montserratMedium40: { ascent: 35, descent: 8, fontSize: 43 },

        montserratBold20: { ascent: 18, descent: 4, fontSize: 22 },
        montserratBold25: { ascent: 23, descent: 5, fontSize: 28 },
        montserratBold30: { ascent: 27, descent: 6, fontSize: 33 },
        montserratBold34: { ascent: 31, descent: 7, fontSize: 38 },
        montserratBold36: { ascent: 33, descent: 7, fontSize: 40 },
        montserratBold40: { ascent: 36, descent: 8, fontSize: 44 },
        montserratBold45: { ascent: 41, descent: 9, fontSize: 50 },
        montserratBold50: { ascent: 45, descent: 10, fontSize: 55 },
        montserratBold55: { ascent: 50, descent: 11, fontSize: 61 },
        montserratBold60: { ascent: 54, descent: 12, fontSize: 67 },
        montserratBold80: { ascent: 73, descent: 16, fontSize: 89 },
        montserratBold140: { ascent: 128, descent: 28, fontSize: 156 },

        montserratBlack50: { ascent: 47, descent: 10, fontSize: 57 },
        montserratBlack100: { ascent: 93, descent: 20, fontSize: 113 },
        montserratBlack230: { ascent: 214, descent: 47, fontSize: 261 },

        arial28: { ascent: 24, descent: 6, fontSize: 30 },
        arial50: { ascent: 44, descent: 11, fontSize: 54 },
    };

    public static layout = {
        // iPad has a system button TL in fullscreen mode
        // iPad System FS Close button approx size: 120x100
        // iPad System FS close button distance from screen edge horizontal: 40px
        IPAD_UI_TL_FS_OFFSET_X: IsIPad() ? 160 : 0,
    };
}